import FileUploadDrawer from "@/file-uploads/FileUploadDrawer";
import { FileUploadAction } from "@/file-uploads/types/file-uploads";

import { useFileContext } from "../../contexts/FileUploadContext";

interface FilesDrawerProps<T extends string> {
  register: (id: T) => {
    opened: boolean;
    onClose: () => void;
    stackId: T;
  };
  filesDrawerId: T;
  encounterId?: string;
}

export function FilesDrawer<T extends string>({
  register,
  filesDrawerId,
  encounterId,
}: FilesDrawerProps<T>) {
  const { selectedFile, setSelectedFile } = useFileContext();
  const { opened, onClose } = register(filesDrawerId);

  const handlePostUpload = (action: FileUploadAction) => {
    // Action parameter is not used in this context - we just close the drawer
    // regardless of whether it was a create or update operation
    onClose();
    setSelectedFile(undefined);
  };

  const handleClose = () => {
    setSelectedFile(undefined);
    onClose();
  };

  return (
    <FileUploadDrawer
      opened={opened}
      onClose={handleClose}
      encounterId={encounterId}
      onPostUpload={handlePostUpload}
      documentReference={selectedFile}
    />
  );
}
